import React, {Component} from 'react';

export default class InnerLoader extends Component {

	constructor(props)
    {
        super(props);
    }

	render() { 
        return (
        	<div className="inner_body">
        		<div className="inner_loader">
        			<img src="/system_images/loader.svg" alt="laoder" />
    			</div>
			</div>
    	);
	}
}